import type { VoiceAiMessageMetadata, VoiceAiMessageRole } from '@pleased-npm/voice-ai-client';

/**
 * Named constants for the @pleased-npm/voice-ai-client message contract.
 *
 * These mirror the string literals owned by the package's `onMessage` types
 * `satisfies` keeps them in sync: if the package adds, removes, or renames a role/kind, the maps below fail to compile.
 */

export const VoiceAiRole = {
  User: 'user',
  Ai: 'ai',
  System: 'system',
} as const satisfies Record<string, VoiceAiMessageRole>;

export const VoiceAiMessageKind = {
  Listening: 'listening',
  ListeningCancel: 'listening_cancel',
  FinalPending: 'final_pending',
  UserRetract: 'user_retract',
  UserDrop: 'user_drop',
  ThinkingStart: 'thinking_start',
  Final: 'final',
  Delta: 'delta',
  AudioStarted: 'audio_started',
  AudioStopped: 'audio_stopped',
  Interrupted: 'interrupted',
  RagSearching: 'rag_searching',
  RagDone: 'rag_done',
  HandoffRequested: 'handoff_requested',
  HandoffConfirmationDone: 'handoff_confirmation_done',
} as const satisfies Record<string, VoiceAiMessageMetadata['kind']>;

/** Renderable row status for the live voice-call transcript UI. */
export const VoiceTranscriptStatus = {
  Listening: 'listening',
  Thinking: 'thinking',
  Streaming: 'streaming',
  Done: 'done',
  Interrupted: 'interrupted',
} as const;

export type VoiceTranscriptStatus = (typeof VoiceTranscriptStatus)[keyof typeof VoiceTranscriptStatus];
